import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomSlidesOutlined = createSvgIcon(
  <path d="M3.75 20.125h9.625c.344 0 .688-.273.688-.625V17h2.062v2.5c0 1.406-1.246 2.5-2.75 2.5H3.75C2.203 22 1 20.906 1 19.5v-8.75c0-1.367 1.203-2.5 2.75-2.5H6.5v1.875H3.75c-.387 0-.688.313-.688.625v8.75c0 .352.301.625.688.625M7.875 4.5c0-1.367 1.203-2.5 2.75-2.5h9.625C21.754 2 23 3.133 23 4.5v8.75c0 1.406-1.246 2.5-2.75 2.5h-9.625c-1.547 0-2.75-1.094-2.75-2.5zm2.75 9.375h9.625c.344 0 .688-.273.688-.625V4.5c0-.313-.344-.625-.688-.625h-9.625c-.387 0-.688.313-.688.625v8.75c0 .352.301.625.688.625" />,
  'CustomSlidesOutlined',
);

export default CustomSlidesOutlined;
